import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { InferRequestType, InferResponseType } from 'hono/client'

import { apiClient } from '@/apiClient.ts'

type ChangeDocumentRequest = InferRequestType<
  (typeof apiClient.documents)[':documentId']['status']['$patch']
>['json']
type ChangeDocumentStatusResponse = InferResponseType<
  (typeof apiClient.documents)[':documentId']['status']['$patch']
>

export type ChangeDocumentStatusArgs = {
  documentId: string
} & ChangeDocumentRequest

export const useChangeDocumentStatus = (
  options?: UseMutationOptions<
    ChangeDocumentStatusResponse,
    Error,
    ChangeDocumentStatusArgs
  >
) =>
  useMutation({
    mutationFn: async (variables) => {
      return await apiClient.documents[':documentId']['status']
        .$patch({
          param: { documentId: variables.documentId },
          json: { status: variables.status },
        })
        .then(async (r) => await r.json())
    },
    mutationKey: ['document-change-status'],
    ...options,
  })
